export const isPastDate = (baseTsSeconds: number, compareTsSeconds?: number): boolean => {
  const baseDate = compareTsSeconds !== undefined ? new Date(baseTsSeconds * 1000) : new Date();

  const compareDate = new Date((compareTsSeconds ?? baseTsSeconds) * 1000);

  return baseDate >= compareDate;
};
